// Skill icon mappings - using Font Awesome 5 icons
// For brands with no FA5 icon, use "text:XX" format (rendered as a small label)
export const skillIcons = {
  // Programming Languages
  Python: "fab fa-python",
  Golang: "text:Go",
  Bash: "fas fa-terminal",
  JavaScript: "fab fa-js",
  Java: "fab fa-java",

  // Cloud Platforms
  AWS: "fab fa-aws",
  GCP: "fab fa-google",
  Azure: "fab fa-microsoft",
  OCI: "fas fa-cloud",
  Bedrock: "fab fa-aws",
  SageMaker: "fab fa-aws",

  // Container & Orchestration
  Kubernetes: "text:k8s",
  Docker: "fab fa-docker",
  EKS: "fab fa-aws",
  GKE: "fab fa-google",
  ECS: "fab fa-aws",
  "Cloud Run": "fab fa-google",
  Karpenter: "fas fa-expand-arrows-alt",
  KEDA: "fas fa-bolt",
  Buildkit: "fas fa-hammer",

  // Infrastructure as Code
  Terraform: "fas fa-layer-group",
  OpenTofu: "fas fa-box-open",
  "AWS CDK": "fab fa-aws",
  CloudFormation: "fab fa-aws",
  Ansible: "fas fa-cogs",
  Helm: "fas fa-anchor",
  "Cloud Custodian": "fas fa-shield-alt",
  IAC: "fas fa-code",

  // CI/CD & GitOps
  Jenkins: "fab fa-jenkins",
  ArgoCD: "fas fa-sync-alt",
  "GitHub Actions": "fab fa-github",
  "AWS CodePipeline": "fab fa-aws",
  "Google Cloud Deploy": "fab fa-google",
  "CI/CD": "fas fa-infinity",
  GitOps: "fab fa-git-alt",
  Skaffold: "fas fa-rocket",
  Git: "fab fa-git-alt",

  // Monitoring & Observability
  Prometheus: "fas fa-chart-line",
  Grafana: "fas fa-chart-bar",
  Datadog: "fas fa-chart-area",
  ELK: "fas fa-search",
  "Sumo Logic": "fas fa-search",
  SIEM: "fas fa-shield-alt",
  SRE: "fas fa-server",

  // AI/ML & Data
  Airflow: "fas fa-wind",
  MLflow: "fas fa-flask",
  "Evidently AI": "fas fa-eye",
  "Temporal.io": "fas fa-clock",

  // Data & Messaging
  Kafka: "fas fa-stream",
  "Pub/Sub": "fas fa-broadcast-tower",
  Dataflow: "fas fa-project-diagram",
  SQS: "fab fa-aws",
  Cassandra: "fas fa-database",
  Aurora: "fab fa-aws",
  RDS: "fab fa-aws",
  ScyllaDB: "fas fa-database",
  PostgreSQL: "fas fa-database",
  MySQL: "fas fa-database",
  MongoDB: "fas fa-database",

  // Languages (no FA5 brand icons for these)
  Groovy: "fas fa-code",

  // Networking & Security
  Networking: "fas fa-network-wired",
  Linux: "fab fa-linux",
};

export const getSkillIcon = (skillName) => {
  // Try exact match first
  if (skillIcons[skillName]) {
    return skillIcons[skillName];
  }

  // Try case-insensitive match
  const lowerSkill = skillName.toLowerCase();
  for (const [key, value] of Object.entries(skillIcons)) {
    if (key.toLowerCase() === lowerSkill) {
      return value;
    }
  }

  // Default icon
  return "fas fa-code";
};
